import { getIdOrNull } from '..'
import apiClient from './apiClient'

export const ACCESS_KEY = 'portal-access-key'
const INSTITUTION_GROUP_KEY = 'institution-group'
export const STUDENT_ACCESS_KEY = 'student-portal-access-key'
export const SCHOOL_ACCESS_KEY = 'school-portal-access-key'

export const getInstitutionInternshipRequestPortal = (institutionUuid, portalAccessKey, isStudentPortal) => apiClient.get(
  null,
  `public/internship-request-portal/institution/${institutionUuid}`,
  { [isStudentPortal ? STUDENT_ACCESS_KEY : SCHOOL_ACCESS_KEY]: portalAccessKey }
)

export const getInstitutionGroupInternshipRequestPortal = (institutionGroupUuid, portalAccessKey, isStudentPortal) => apiClient.get(
  null,
  `public/internship-request-portal/institution-group/${institutionGroupUuid}`,
  { [isStudentPortal ? STUDENT_ACCESS_KEY : SCHOOL_ACCESS_KEY]: portalAccessKey }
)

export const getPortalOwnerName = ({ institution, institutionGroup } = {}) => {
  if (getIdOrNull(institutionGroup) !== null) {
    return institutionGroup.name
  }

  return getIdOrNull(institution) !== null ? institution.name : ''
}

export const getPortalAddressee = ({ institution, institutionGroup } = {}) => {
  const institutionGroupId = getIdOrNull(institutionGroup)

  return institutionGroupId === null
    ? { institution: getIdOrNull(institution) }
    : { [INSTITUTION_GROUP_KEY]: institutionGroupId }
}
